import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from "@mui/material/Typography";

const MpgErrorDialog = ({ title, content, open, extraLogicHandlerOnOK, sx }) => {
    const internalSx = {
        zIndex: 1500
    }

    const [openDialog, setOpenDialog] = useState(false)

    useEffect(() => {
        if (!!open) {
            setOpenDialog(true)
        } else {
            setOpenDialog(false)
        }
    }, [open])

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpenDialog(false);
        }
    };

    const callExtraLogicHandlerOnOK = () => {
        if (!!extraLogicHandlerOnOK) {
            extraLogicHandlerOnOK()
        }
        handleClose()
    }

    let dialogContent = ""
    if (content?.includes("\n")) {
        dialogContent = content.split('\n').map(str => <p>{str}</p>);
    } else {
        dialogContent = content
    }

    return (
        <div>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={[internalSx, sx]}
            >
                <DialogTitle id="alert-dialog-title" sx={{ color: 'red', fontWeight: 'bold' }}>
                    {
                        !!title ? title : "Oops, something went wrong...!"
                    }
                </DialogTitle>
                <DialogContent>
                    <Typography
                        variant="body2"
                        align="center"
                    >
                        {
                            !!dialogContent ? dialogContent : `This action has failed. Please wait for sometime. If issue persists,  contact support team.`
                        }
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        callExtraLogicHandlerOnOK()
                    }}
                        autoFocus
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default MpgErrorDialog